import React, { useEffect, useRef } from 'react';
// import { useT } from 'talkr';
import s from './index.module.scss';
import steps from '../../../survey/steps';
import arrow from './img/arrow.svg';
import logo from './img/logo.svg';

function BigPhotoStartScreen() {
	// const { T } = useT();
	const ref = useRef();

	useEffect(() => {
		steps.setStepStatus({
			stepName: 'big_photo_start_screen',
			stepStatus: true
		});
	}, []);

	function goForward() {
		ref.current.classList.add(`${s.bigPhotoStartScreen_fade}`);
		setTimeout(() => {
			steps.navigate.forward({
				preventAction: 500
			});
			ref.current.classList.remove(`${s.bigPhotoStartScreen_fade}`);
		}, 500);
	}

	return (
		<div className={s.bigPhotoStartScreen} ref={ref}>
			<div className={s.bigPhotoStartScreen_header}>
				<img src={logo} alt='verv' />
				Verv: Home Fitness Workout
			</div>
			<div>
				<div className={s.bigPhotoStartScreen_smallLine}>
					Get a new you in 16 weeks
				</div>
				<div className={s.bigPhotoStartScreen_bigLine}>
					Find out what you can achieve with our fitness app
				</div>
				<div className={s.bigPhotoStartScreen_smallLine}>
					To start please select a goal:
				</div>
				<div className={s.bigPhotoStartScreen_arrow}>
					<img src={arrow} alt='arrow' />
				</div>
				<div className={s.bigPhotoStartScreen_buttons}>
					<button
						onClick={goForward}
						className={s.bigPhotoStartScreen_button}
						type="button">Improve health for better life
					</button>
					<button
						onClick={goForward}
						className={s.bigPhotoStartScreen_button}
						type="button">Lose weight for better life
					</button>
				</div>
			</div>
			<div className={s.bigPhotoStartScreen_footer}>
				Results vary depending on your starting point, goals and effort.
			</div>
		</div>
	);
}

export default BigPhotoStartScreen;
